import { useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Button } from '../../rapid-ui'
import { metaTransformDefault } from '../../views'
import { useSimulatorFocus } from '../simulator-tools/use-simulator-focus'
import { storyAdMetaBackdropTransformAtom } from '../state/story-ad-atoms'
import { trackToolClicked } from '../tracking'

export function StoryAdBackdropLayerControls() {
	const { t } = useTranslation('common')
	const setBackdropTransform = useSetAtom(storyAdMetaBackdropTransformAtom)

	const { handleFocus } = useSimulatorFocus({
		focusTargetId: { target: 'story-ad(backdrop)' },
	})

	return (
		<div className="text-left ml-10 mb-4 grid grid-cols-[auto_1fr] items-center gap-2">
			<div className="text-xs text-grey-600"></div>
			<div className="text-xs flex items-center gap-2">
				<Button
					size="tiny"
					type="subtle"
					onClick={() => {
						trackToolClicked('backdrop_transform', 'story')
						handleFocus()
					}}
				>
					{t('editor.layerManager.transformBackdrop')}
				</Button>
				<Button
					size="tiny"
					type="subtle"
					onClick={() => {
						trackToolClicked('backdrop_reset', 'story')
						setBackdropTransform({ ...metaTransformDefault })
					}}
				>
					{t('editor.layerManager.reset')}
				</Button>
			</div>
		</div>
	)
}
